import { Flag, MessageSquare } from "lucide-react";

const FEEDBACK_PATH = `${import.meta.env.BASE_URL.replace(/\/$/, "")}/feedback`;

const DEFAULT_MESSAGE =
  "Your beta access has ended. Thanks for helping test GOBAZAAR — we'll be in touch about what's next.";

/**
 * Forced, no-escape interstitial shown when an admin ends a user's beta access.
 * There is intentionally no "back" or "dismiss" path — the only action is to
 * share feedback. Admins are never shown this (the API returns 200 for them).
 */
export function BetaEndedScreen({ message }: { message?: string | null }) {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background px-6 text-center">
      <div className="w-20 h-20 rounded-full bg-accent/15 border border-accent/30 flex items-center justify-center mb-6">
        <Flag className="w-9 h-9 text-accent" />
      </div>
      <h1 className="text-4xl font-bold tracking-tight text-foreground mb-4">Beta Ended</h1>
      <p className="text-muted-foreground max-w-md leading-relaxed mb-8">{message || DEFAULT_MESSAGE}</p>
      <a
        href={FEEDBACK_PATH}
        className="inline-flex items-center gap-2 rounded-xl bg-accent hover:bg-accent/90 text-accent-foreground font-semibold px-6 py-3 transition-colors"
      >
        <MessageSquare className="w-4 h-4" /> Share Beta Feedback
      </a>
    </div>
  );
}
